import { forwardRef } from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from './cn'

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: ReactNode
  children?: ReactNode
  className?: string
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card({ title, children, className = '', ...props }, ref) {
  return (
    <div ref={ref} className={cn('bg-white rounded-surface shadow-card border border-line', className)} {...props}>
      {title && (
        <div className="px-6 py-4 border-b border-line">
          <h3 className="text-base font-semibold font-display text-strong">{title}</h3>
        </div>
      )}
      <div className="px-6 py-4">
        {children}
      </div>
    </div>
  )
})
